module.exports = __webpack_public_path__ + "static/media/app-version.004ec606.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/venueStatus/app-version.svg
// module id = 350
// module chunks = 1